import * as fromCredits from '../actions/credits.action';
import { Credits } from '@usimweb/core/models';

export interface CreditsState {
  credits: Credits;
  loading: boolean;
  loaded: boolean;
}

export const initialState: CreditsState = {
  credits: {} as Credits,
  loading: false,
  loaded: false,
};

export function reducer(state = initialState, action: fromCredits.CreditsActions): CreditsState {
  switch (action.type) {
    case fromCredits.LOAD_CREDITS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromCredits.LOAD_CREDITS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromCredits.LOAD_CREDITS_SUCCESS: {
      const credits = action.payload;

      return {
        ...state,
        credits,
        loading: false,
        loaded: true,
      };
    }
  }

  return state;
}

export const getCredits = (state: CreditsState) => state.credits;
export const getCreditsLoading = (state: CreditsState) => state.loading;
export const getCreditsLoaded = (state: CreditsState) => state.loaded;
